/*
  /api/staff/clubs/<parent_lookup_game__round__event__club>/events/
  <parent_lookup_game__round__event>/rounds/<parent_lookup_game__round>/scores/
 */

import api, { request } from '../../../api';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { IRoundScoresStore } from './store';

export interface IScoresActions extends IActionGroup {
  get: (groupId: number) => { scores?: IRoundScoresStore; errors?: IErrorsStore };
  save: (groupId: number, scores: any) => any;
  updateGame: (
    gameId: number,
    data: any,
    playerSignature?: Blob
  ) => { games?: IRoundScoresStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  get: async (_: IStore, clubId: number, eventId: number, roundId: number) => {
    // if (Object.keys(state.games).length) {
    //   return { games: state.games };
    // }

    const response = await request.get(`${api.admin.eventRounds(clubId, eventId, roundId)}scores`);

    if (response.error) {
      return { errors: { games: { msg: 'Error retrieving the Games List.' } } };
    }

    return {
      roundScores: {
        [roundId]: response
      }
    };
  },
  save: async (state: IStore, clubId: number, eventId: number, roundId: number, data: any) => {
    const response = await request.patch(
      `${api.admin.eventRounds(clubId, eventId, roundId)}scores`,
      data
    );

    if (response.error) {
      return { errors: { games: { msg: 'Error saving the scores.' } } };
    }

    return {
      roundScores: {
        [roundId]: (state.roundScores[roundId] || [])
          .filter(rs => !response.find((score: any) => score.id === rs.id))
          .concat(response)
      }
    };
  }
};

export default actions;
